import { render, staticRenderFns } from "./ProfessionPageSectionAdviceBlock.vue?vue&type=template&id=a868d1a2&scoped=true"
import script from "./ProfessionPageSectionAdviceBlock.vue?vue&type=script&lang=js"
export * from "./ProfessionPageSectionAdviceBlock.vue?vue&type=script&lang=js"
import style0 from "./ProfessionPageSectionAdviceBlock.vue?vue&type=style&index=0&id=a868d1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a868d1a2",
  null
  
)

export default component.exports